module.exports = __webpack_public_path__ + "assets/ed7dca3fa5882ffa921c40c730199e42.mp4";